import SidebarButton from '@/hoc/SidebarMenu/bones/SidebarButton'
import type { MenuLogoutView } from '../types'
import { StyledMenuEntrySlot } from '../styled-components'

interface MenuLogoutProps {
  logout: MenuLogoutView | null
  expanded: boolean
  fill: boolean
}

const MenuLogout = ({ logout, expanded, fill }: MenuLogoutProps) => {
  if (!logout) return null

  return (
    <StyledMenuEntrySlot data-menu-slot $fill={fill} $expanded={expanded} onMouseEnter={logout.onMouseEnter}>
      <SidebarButton
        text={logout.label}
        url='#'
        icon={logout.icon}
        floating
        expanded={expanded}
        clickHandler={logout.onClick}
      />
    </StyledMenuEntrySlot>
  )
}

export default MenuLogout
